import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../utils/analytics";

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent("virtual_pageview", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title
    });
  }, [location]);
};

export default usePageTracking;
